import React from 'react'
import {
    Form,
    Input,
    Radio,
    Space,
    Button, Selector, TextArea, ImageUploader, DatePicker, NavBar, Grid,Image,Toast
} from 'antd-mobile-v5';
import dayjs from 'dayjs'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../Space/index.css'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
    GetSystemMemorys,GetDataDictionarysByCode,CreateOrderJsPay,GetWXUserByOpenId
} from '../../service/service';
import { environment } from '../../service/baseUrl';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            userInfo: {},
            fileList: [],

            space: {},

            fileInfo: {
                sumFileSize: 300,
                useSumFileSize: 0,

                imgSumFileSize: 0,
                videoSumFileSize: 0,
                yuSumFileSize: 0,
                lySumFileSize: 0,
                endTime: "",
            },
        };
    }

    componentDidMount() {
        var that = this;

        GetDataDictionarysByCode("KJJGGL").then(res => {
            if (res.success) {
                if (res.result.length > 0) {
                    that.setState({
                        space: {
                            id: res.result[0].id,
                            name: res.result[0].name,
                            price: res.result[0].value,
                            size: res.result[0].order,
                        }
                    })
                }
            }
        })

        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            this.setState({
                id: id,
            })

            this.initSystemMemorys(id);
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })
    }

    initSystemMemorys(id) {
        var that = this;
        var user = localStorage.getItem("user");

        GetSystemMemorys(id).then(res => {
            if (res.success) {
                var size = 300;
                if (user != null || user != undefined) {
                    user = JSON.parse(user);
                    if (user.planetSizes != null) {
                        var models = user.planetSizes.filter(x => x.planetId == id);
                        if (models.length > 0) {
                            size = models[0].fileSumSize;
                            this.setState({
                                endTime: models[0].endTime
                            })
                        }
                    }
                }
                var fileInfo = {
                    sumFileSize: size,
                    useSumFileSize: 0,
                    imgSumFileSize: 0,
                    videoSumFileSize: 0,
                    yuSumFileSize: 0,
                    lySumFileSize: 0,
                }
                res.result.map(item => {

                    switch (item.scoureName) {
                        case "Img":
                        case "XC":
                            fileInfo.imgSumFileSize += item.fileSize;
                            break;
                        case "Video":
                            fileInfo.videoSumFileSize += item.fileSize;
                            break;
                        case "YY":
                            fileInfo.yuSumFileSize += item.fileSize;
                            break;
                        case "LY":
                            fileInfo.lySumFileSize += item.fileSize;
                            break;
                        default:
                            break;
                    }
                    // if (item.fileUrl.includes("Video")) {
                    // } else if (item.fileUrl.includes("yuyin")) {
                    // } else {
                    //     if (item.fileUrl.includes("Img")) {
                    //     }
                    // }

                    fileInfo.useSumFileSize += item.fileSize;
                })
                that.setState({
                    fileInfo: fileInfo
                })
            }
        })

    }
    
    // 格式化文件大小显示
    formatFileSize(sizeInMB) {
        if (sizeInMB >= 1024) {
            // 转换为GB并保留一位小数
            const sizeInGB = sizeInMB / 1024;
            return `${sizeInGB.toFixed(1)}GB`;
        }
        // 小于1024MB，直接显示整数MB
        return `${Math.round(sizeInMB)}MB`;
    }

    submitForm = () => {
        var that = this;
        if (that.state.space.id > 0) {
            var data = {
                planetId: that.state.id,
                productTypeId: that.state.space.id,
            };

            CreateOrderJsPay(data).then(res => {
                if (res.success) {
                    that.jsApiCall(res.result);
                } else {
                    Toast.show("内部错误！");
                }
            })
        } else {
            Toast.show("内部错误！");
        }

    }

    jsApiCall(wxJsApiParam) {
        var that = this;
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            JSON.parse(wxJsApiParam),//josn串
            function (res) {
                switch (res.err_msg) {
                    case 'get_brand_wcpay_request:cancel':

                        Toast.show("用户取消支付!");
                        break;
                    case 'get_brand_wcpay_request:fail':

                        Toast.show("支付失败！（" + res.err_desc + "）");
                        break;
                    case 'get_brand_wcpay_request:ok':

                        Toast.show({
                          icon: 'success',
                          content: '购买成功！',
                        })

                        GetWXUserByOpenId().then(res => {
                            if (res.success) {
                                if (res.result.headImg != null && res.result.headImg != "") {
                                    if (res.result.headImg.indexOf("https://") > -1) {
                                        var urls = res.result.headImg.split("https://").filter(Boolean);
                                        res.result.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                                    } else {
                                        res.result.headImg = environment.apiEndpoint + "/NNFiles/Img/" + res.result.headImg;
                                    }
                                }
                                localStorage.setItem("user", JSON.stringify(res.result))

                                that.initSystemMemorys(that.state.id);
                            }
                        })
            
                        break;
                    default:
                        Toast.info(JSON.stringify(res), 1);
                        break;
                }
            }
        );
    }


    render() {

        return (
            <div style={{ width: "100%", height: "100%" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/formView', { replace: true, state: { id: this.state.id } }); // 传递状态
                }}>
                    空间管理
                </NavBar>

                <div style={{
                    height: "85%", backgroundColor: "rgb(227 227 227)", paddingTop: "7%"
                }}>

                    <div style={{
                        width: "92%", backgroundColor: "#fff", marginLeft: "4%", borderRadius: "2%",
                        padding: "3% 5% 7% 5%"
                    }}>

                        <div>
                            <span style={{ fontSize: "20px", fontWeight: "600" }}>
                                {this.formatFileSize(this.state.fileInfo.sumFileSize)}
    </span>

                            {
                                this.state.endTime != "" ?
                                    <span style={{ fontSize: "14px", marginLeft: "10px" }}>
                                        付费空间失效日期：
                                        <span style={{ color: "#f00" }}>
                                            {this.state.endTime}
                                        </span>
                                    </span> : <span style={{ fontSize: "14px", marginLeft: "10px" }}>
                                        免费空间使用情况
                                    </span>
                            }
                        </div>

                        <div style={{ position: "relative", width: "100%", height: 20, marginTop: "5px" }}>
                            <Image
                                src={"https://api.weibinyi.com/images/niannian/1/6-10.png"}
                                width={"100%"}
                                height={20}
                                fit='cover'
                                style={{ position: "relative", zIndex: 1 }}
                            />
                            <Image
                                src={"https://api.weibinyi.com/images/niannian/1/6-11.png"}
                                // width={parseInt((this.state.fileInfo.useSumFileSize
                                //     / this.state.fileInfo.sumFileSize) * 100) + "%"}
                                width={Math.min(parseInt((this.state.fileInfo.useSumFileSize
                                    / this.state.fileInfo.sumFileSize) * 100), 100) + "%"}
                                height={20}
                                fit='cover'
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    zIndex: 2,
                                }}
                            />
                        </div>

                        <div style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            width: "100%", marginTop: "5px", marginBottom: "10%"
                        }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-12.png"}
                                    width={14}
                                    height={14}
                                    fit='cover'
                                    style={{ display: "inline-flex", marginRight: "4px" }}
                                />
                                <span>已使用{this.formatFileSize(this.state.fileInfo.useSumFileSize)}</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-13.png"}
                                    width={14}
                                    height={14}
                                    fit='cover'
                                    style={{ display: "inline-flex", marginRight: "4px" }}
                                />
                                {/* <span>剩余{this.formatFileSize(this.state.fileInfo.sumFileSize
                                    - this.state.fileInfo.useSumFileSize)}可用</span> */}
                                <span>
                                    剩余{this.formatFileSize(
                                        Math.max(0, this.state.fileInfo.sumFileSize - this.state.fileInfo.useSumFileSize)
                                    )}可用
                                </span>
                            </div>
                        </div>

                        <div style={{ fontSize: "17px", marginBottom: "12px" }}>
                            使用情况如下：
                        </div>

                        <div>
                            <div style={{ fontSize: "15px" }}>
                                <span>
                                    图片
</span>
                                <span style={{ marginLeft: "15px", fontWeight: "600", fontSize: "16px" }}>
                                    {this.formatFileSize(this.state.fileInfo.imgSumFileSize)}
</span>
                            </div>
                            <div style={{ position: "relative", width: "100%", height: 12, marginTop: "3px" }}>
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-10.png"}
                                    width={"100%"}
                                    height={12}
                                    fit='cover'
                                    style={{ position: "relative", zIndex: 1 }}
                                />
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-11.png"}
                                    // width={"50%"}
                                    width={parseInt((this.state.fileInfo.imgSumFileSize
                                    / this.state.fileInfo.sumFileSize) * 100) + "%"}
                                    height={12}
                                    fit='cover'
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 2,
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{ marginTop: "10px" }}>
                            <div style={{ fontSize: "15px" }}>
                                <span>
                                    视频
</span>
                                <span style={{ marginLeft: "15px", fontWeight: "600", fontSize: "16px" }}>
                                    {this.formatFileSize(this.state.fileInfo.videoSumFileSize)}
</span>
                            </div>
                            <div style={{ position: "relative", width: "100%", height: 12, marginTop: "3px" }}>
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-10.png"}
                                    width={"100%"}
                                    height={12}
                                    fit='cover'
                                    style={{ position: "relative", zIndex: 1 }}
                                />
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-11.png"}
                                    // width={"30%"}
                                    width={parseInt((this.state.fileInfo.videoSumFileSize
                                        / this.state.fileInfo.sumFileSize) * 100) + "%"}
                                    height={12}
                                    fit='cover'
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 2,
                                    }}
                                />
                            </div>
                        </div>
                        {/* <div style={{ marginTop: "10px" }}>
                            <div style={{ fontSize: "15px" }}>
                                <span>
                                    声音
</span>
                                <span style={{ marginLeft: "15px", fontWeight: "600", fontSize: "16px" }}>
                                    {this.formatFileSize(this.state.fileInfo.yuSumFileSize)}
</span>
                            </div>
                            <div style={{ position: "relative", width: "100%", height: 12, marginTop: "3px" }}>
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-10.png"}
                                    width={"100%"}
                                    height={12}
                                    fit='cover'
                                    style={{ position: "relative", zIndex: 1 }}
                                />
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-11.png"}
                                    width={parseInt((this.state.fileInfo.yuSumFileSize
                                        / this.state.fileInfo.sumFileSize) * 100) + "%"}
                                    height={12}
                                    fit='cover'
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 2,
                                    }}
                                />
                            </div>
                        </div> */}
                        <div style={{ marginTop: "10px" }}>
                            <div style={{ fontSize: "15px" }}>
                                <span>
                                    留言
</span>
                                <span style={{ marginLeft: "15px", fontWeight: "600", fontSize: "16px" }}>
                                    {this.formatFileSize(this.state.fileInfo.lySumFileSize)}
</span>
                            </div>
                            <div style={{ position: "relative", width: "100%", height: 12, marginTop: "3px" }}>
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-10.png"}
                                    width={"100%"}
                                    height={12}
                                    fit='cover'
                                    style={{ position: "relative", zIndex: 1 }}
                                />
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/1/6-11.png"}
                                    // width={"0%"}
                                    width={parseInt((this.state.fileInfo.lySumFileSize
                                        / this.state.fileInfo.sumFileSize) * 100) + "%"}
                                    height={12}
                                    fit='cover'
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 2,
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ marginTop: "10%", fontSize: "20px" }}>
                            {this.state.space.name}
                        </div>

                        <div style={{ marginTop: "7%" }}>
                            <Grid columns={6} gap={8} style={{ marginTop: "12px" }}>
                                <Grid.Item span={3}>
                                    <div style={{
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/1/2-20.png')"
                                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                        , width: "90%", textAlign: "center", fontSize: "15px", lineHeight: "38px"
                                        , fontWeight: "600", color: "#fff"
                                    }} onClick={() => {
                                        this.submitForm();
                                    }}>
                                        <span style={{ fontSize: "17px" }}>{this.state.space.price}</span> / 年
                            </div>
                                </Grid.Item>
                                <Grid.Item span={3}>
                                    <div style={{
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/1/2-20.png')"
                                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                        , width: "90%", textAlign: "center", fontSize: "15px", lineHeight: "38px"
                                        , fontWeight: "600", color: "#fff", float: "right"
                                    }} onClick={() => {
                                        this.submitForm();
                                    }}>
                                        点 击 扩 容
                            </div>
                                </Grid.Item>
                            </Grid>
                        </div>

                    </div>

                </div>



                <BottomMenu position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);